export default __webpack_public_path__ + "static/media/exclamation_circle_grey.286209c9.svg";